import React from 'react';

import { Box, CircularProgress, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import action_library_messages from 'messages/action_library_messages';

const LoadingState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box display='flex' justifyContent='center' p={2}>
      <CircularProgress size={24} />
      <Box ml={2}>
        <Typography>{t(action_library_messages.instance.asset_selection.loading)}</Typography>
      </Box>
    </Box>
  );
};

export default LoadingState;
